import { Col, Container, Row, Form } from "react-bootstrap";
import FixStar from "./FixStar";
const SPRINKLECRM_URL = process.env.REACT_APP_PROFILE === 'dev' ? process.env.REACT_APP_SPRINKLECRM_URL_DEV : process.env.REACT_APP_PROFILE === 'uat' ? process.env.REACT_APP_SPRINKLECRM_URL_UAT : process.env.REACT_APP_SPRINKLECRM_URL_PROD;
interface Result {
    createdAt: string,
    custCode: string,
    rating: number,
    comment: string,
    contactId: string,
    contactBack: boolean
}

export default function ResultComponent({ createdAt, custCode, rating, comment, contactId, contactBack }: Result): JSX.Element {
    return (
        <Container>
            <Row>
                <Col lg={1} className='result-custcode'>
                    <a href={`${SPRINKLECRM_URL}/${contactId}`} target="_blank" rel="noopener noreferrer">{custCode}</a>
                </Col>
                <Col lg={2}>
                    <FixStar stars={5} fixStar={rating} />
                </Col>
                <Col lg={2}>
                    <Form.Check className='contactback-checkbox' checked={contactBack} label='Contact Back' disabled />
                </Col>
            </Row>
            <Row>
                <Col className='result-created-at'>
                    Reviewed on: {createdAt}
                </Col>
            </Row>
            <Row>
                <Col className='result-comment'>
                    {comment}
                </Col>
            </Row>
        </Container>
    )
}